import React from "react"

interface CenteredLayoutProps {
  children?: React.ReactNode
}

export const CenteredLayout: React.FC<CenteredLayoutProps> = (props) => {
  return (
    <div className="flex flex-grow justify-center items-center">
      {props.children}
    </div>
  )
}

export default CenteredLayout
